import { render, staticRenderFns } from "./ProjectNodeEditor.vue?vue&type=template&id=03d2874f&"
import script from "./ProjectNodeEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectNodeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports